/**
 * @fileoverview gRPC-Web generated client stub for risk
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: risk/risk.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var common_model_pb = require('../common/model_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.risk = require('./risk_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.risk.RiskServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.risk.RiskServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.GetRisksRequest,
 *   !proto.risk.GetRisksResponse>}
 */
const methodDescriptor_RiskService_GetRisks = new grpc.web.MethodDescriptor(
  '/risk.RiskService/GetRisks',
  grpc.web.MethodType.UNARY,
  proto.risk.GetRisksRequest,
  proto.risk.GetRisksResponse,
  /**
   * @param {!proto.risk.GetRisksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.GetRisksResponse.deserializeBinary
);


/**
 * @param {!proto.risk.GetRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.GetRisksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.GetRisksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.getRisks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/GetRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_GetRisks,
      callback);
};


/**
 * @param {!proto.risk.GetRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.GetRisksResponse>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.getRisks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/GetRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_GetRisks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.GetRisksByIdsRequest,
 *   !proto.risk.GetRisksResponse>}
 */
const methodDescriptor_RiskService_GetRisksByIds = new grpc.web.MethodDescriptor(
  '/risk.RiskService/GetRisksByIds',
  grpc.web.MethodType.UNARY,
  proto.risk.GetRisksByIdsRequest,
  proto.risk.GetRisksResponse,
  /**
   * @param {!proto.risk.GetRisksByIdsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.GetRisksResponse.deserializeBinary
);


/**
 * @param {!proto.risk.GetRisksByIdsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.GetRisksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.GetRisksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.getRisksByIds =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/GetRisksByIds',
      request,
      metadata || {},
      methodDescriptor_RiskService_GetRisksByIds,
      callback);
};


/**
 * @param {!proto.risk.GetRisksByIdsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.GetRisksResponse>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.getRisksByIds =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/GetRisksByIds',
      request,
      metadata || {},
      methodDescriptor_RiskService_GetRisksByIds);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.CreateOrUpdateRisksRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_CreateOrUpdateRisks = new grpc.web.MethodDescriptor(
  '/risk.RiskService/CreateOrUpdateRisks',
  grpc.web.MethodType.UNARY,
  proto.risk.CreateOrUpdateRisksRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.CreateOrUpdateRisksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.CreateOrUpdateRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.createOrUpdateRisks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/CreateOrUpdateRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_CreateOrUpdateRisks,
      callback);
};


/**
 * @param {!proto.risk.CreateOrUpdateRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.createOrUpdateRisks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/CreateOrUpdateRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_CreateOrUpdateRisks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.DeleteRisksRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_DeleteRisks = new grpc.web.MethodDescriptor(
  '/risk.RiskService/DeleteRisks',
  grpc.web.MethodType.UNARY,
  proto.risk.DeleteRisksRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.DeleteRisksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.DeleteRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.deleteRisks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/DeleteRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_DeleteRisks,
      callback);
};


/**
 * @param {!proto.risk.DeleteRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.deleteRisks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/DeleteRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_DeleteRisks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.ToggleRiskLinksRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_ToggleRiskLinks = new grpc.web.MethodDescriptor(
  '/risk.RiskService/ToggleRiskLinks',
  grpc.web.MethodType.UNARY,
  proto.risk.ToggleRiskLinksRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.ToggleRiskLinksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.ToggleRiskLinksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.toggleRiskLinks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/ToggleRiskLinks',
      request,
      metadata || {},
      methodDescriptor_RiskService_ToggleRiskLinks,
      callback);
};


/**
 * @param {!proto.risk.ToggleRiskLinksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.toggleRiskLinks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/ToggleRiskLinks',
      request,
      metadata || {},
      methodDescriptor_RiskService_ToggleRiskLinks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.risk.DownloadRiskCSVResponse>}
 */
const methodDescriptor_RiskService_DownloadRiskCSV = new grpc.web.MethodDescriptor(
  '/risk.RiskService/DownloadRiskCSV',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.risk.DownloadRiskCSVResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.DownloadRiskCSVResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.DownloadRiskCSVResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.DownloadRiskCSVResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.downloadRiskCSV =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/DownloadRiskCSV',
      request,
      metadata || {},
      methodDescriptor_RiskService_DownloadRiskCSV,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.DownloadRiskCSVResponse>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.downloadRiskCSV =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/DownloadRiskCSV',
      request,
      metadata || {},
      methodDescriptor_RiskService_DownloadRiskCSV);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.risk.GetRiskCategoryOptionResponse>}
 */
const methodDescriptor_RiskService_GetRiskCategoryOption = new grpc.web.MethodDescriptor(
  '/risk.RiskService/GetRiskCategoryOption',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.risk.GetRiskCategoryOptionResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.GetRiskCategoryOptionResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.GetRiskCategoryOptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.GetRiskCategoryOptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.getRiskCategoryOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/GetRiskCategoryOption',
      request,
      metadata || {},
      methodDescriptor_RiskService_GetRiskCategoryOption,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.GetRiskCategoryOptionResponse>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.getRiskCategoryOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/GetRiskCategoryOption',
      request,
      metadata || {},
      methodDescriptor_RiskService_GetRiskCategoryOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.UpsertRiskCategoryOptionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_UpsertRiskCategoryOption = new grpc.web.MethodDescriptor(
  '/risk.RiskService/UpsertRiskCategoryOption',
  grpc.web.MethodType.UNARY,
  proto.risk.UpsertRiskCategoryOptionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.UpsertRiskCategoryOptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.UpsertRiskCategoryOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.upsertRiskCategoryOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/UpsertRiskCategoryOption',
      request,
      metadata || {},
      methodDescriptor_RiskService_UpsertRiskCategoryOption,
      callback);
};


/**
 * @param {!proto.risk.UpsertRiskCategoryOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.upsertRiskCategoryOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/UpsertRiskCategoryOption',
      request,
      metadata || {},
      methodDescriptor_RiskService_UpsertRiskCategoryOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.DeleteRiskCategoryOptionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_DeleteRiskCategoryOption = new grpc.web.MethodDescriptor(
  '/risk.RiskService/DeleteRiskCategoryOption',
  grpc.web.MethodType.UNARY,
  proto.risk.DeleteRiskCategoryOptionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.DeleteRiskCategoryOptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.DeleteRiskCategoryOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.deleteRiskCategoryOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/DeleteRiskCategoryOption',
      request,
      metadata || {},
      methodDescriptor_RiskService_DeleteRiskCategoryOption,
      callback);
};


/**
 * @param {!proto.risk.DeleteRiskCategoryOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.deleteRiskCategoryOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/DeleteRiskCategoryOption',
      request,
      metadata || {},
      methodDescriptor_RiskService_DeleteRiskCategoryOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.SetRiskAssigneesRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_SetAssignees = new grpc.web.MethodDescriptor(
  '/risk.RiskService/SetAssignees',
  grpc.web.MethodType.UNARY,
  proto.risk.SetRiskAssigneesRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.SetRiskAssigneesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.SetRiskAssigneesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.setAssignees =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/SetAssignees',
      request,
      metadata || {},
      methodDescriptor_RiskService_SetAssignees,
      callback);
};


/**
 * @param {!proto.risk.SetRiskAssigneesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.setAssignees =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/SetAssignees',
      request,
      metadata || {},
      methodDescriptor_RiskService_SetAssignees);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.risk.RiskInternalServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.risk.RiskInternalServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.CreateOrUpdateRisksInternalRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskInternalService_CreateOrUpdateRisks = new grpc.web.MethodDescriptor(
  '/risk.RiskInternalService/CreateOrUpdateRisks',
  grpc.web.MethodType.UNARY,
  proto.risk.CreateOrUpdateRisksInternalRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.CreateOrUpdateRisksInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.CreateOrUpdateRisksInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskInternalServiceClient.prototype.createOrUpdateRisks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskInternalService/CreateOrUpdateRisks',
      request,
      metadata || {},
      methodDescriptor_RiskInternalService_CreateOrUpdateRisks,
      callback);
};


/**
 * @param {!proto.risk.CreateOrUpdateRisksInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskInternalServicePromiseClient.prototype.createOrUpdateRisks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskInternalService/CreateOrUpdateRisks',
      request,
      metadata || {},
      methodDescriptor_RiskInternalService_CreateOrUpdateRisks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.ToggleRiskLinksInternalRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskInternalService_ToggleRiskLinks = new grpc.web.MethodDescriptor(
  '/risk.RiskInternalService/ToggleRiskLinks',
  grpc.web.MethodType.UNARY,
  proto.risk.ToggleRiskLinksInternalRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.ToggleRiskLinksInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.ToggleRiskLinksInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskInternalServiceClient.prototype.toggleRiskLinks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskInternalService/ToggleRiskLinks',
      request,
      metadata || {},
      methodDescriptor_RiskInternalService_ToggleRiskLinks,
      callback);
};


/**
 * @param {!proto.risk.ToggleRiskLinksInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskInternalServicePromiseClient.prototype.toggleRiskLinks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskInternalService/ToggleRiskLinks',
      request,
      metadata || {},
      methodDescriptor_RiskInternalService_ToggleRiskLinks);
};


module.exports = proto.risk;

